import { Stack } from '@mui/material';
import styled from 'styled-components';

export const VendorContainer = styled(Stack)`
  && {
    gap: 0.5rem;
    color: ${({ theme }) => theme.palette.secondary.main};
  }
`;
